import { render } from "./Appointmentlist.vue?vue&type=template&id=1dbd8f14"
import script from "./Appointmentlist.vue?vue&type=script&lang=js"
export * from "./Appointmentlist.vue?vue&type=script&lang=js"

import "./Appointmentlist.vue?vue&type=style&index=0&id=1dbd8f14&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__